import {
  authent,
  getUserInfo,
  contract,
  voidContract,
  sendContractDing,
  getContractInfo,
  saveOrderContractResource,
  upLoadImage,
  buildCode,
  sendEmail,
  getUploadToken
} from '@/api/contract.js'

const state = {
}

const mutations = {
}

const actions = {
  // 获取实名认证地址
  authent(temp, data) {
    return new Promise((resolve, reject) => {
      authent(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getUserInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getUserInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  contract({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      contract(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  voidContract({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      voidContract(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  sendContractDing({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      sendContractDing(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getContractInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getContractInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveOrderContractResource({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveOrderContractResource(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  sendEmail({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      sendEmail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getUploadToken({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      if (state.upload_token) {
        resolve(state.upload_token)
        return
      }
      getUploadToken(data).then(response => {
        const uploadToken = response.data.data.uploadToken
        resolve(uploadToken)
      }).catch(error => {
        reject(error)
      })
    })
  },
  async upLoadImage({ state, commit, dispatch }, data) {
    try {
      const image_type_key = data.params.jsonText ? JSON.parse(data.params.jsonText).image_type_key : data.params.image_type_key
      const file = data.file
      const uploadToken = await dispatch('getUploadToken')
      const nameArr = file.name.split('.')
      const suffix = nameArr.pop()
      const name = nameArr.join('.') + '-' + (parseInt((new Date().getTime() / 1000)) + '_' + parseInt(Math.random() * 1000))
      const res = await upLoadImage(data.file, {
        token: uploadToken,
        key: image_type_key + '_' + name + '.' + suffix
      })
      return {
        file_info: {
          name: res.data.key,
          url: process.env.VUE_APP_QINIU_URL + '/' + res.data.key
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return await dispatch('upLoadImage', data)
      }
      throw error
    }
  },
  // 获取门店包列表
  buildCode(temp, data) {
    return new Promise((resolve, reject) => {
      buildCode(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
